import { render } from "./nav_panel.vue?vue&type=template&id=251f59a4"
import script from "./nav_panel.js?vue&type=script&lang=js"
export * from "./nav_panel.js?vue&type=script&lang=js"

import "./nav_panel.vue?vue&type=style&index=0&id=251f59a4&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__